import * as React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import SubjectMergeEditor from "../../SubjectMergeEditor";
import {BaseConfigureSubjectMergesPage, BaseConfigureSubjectMergesPageProps} from "./BaseConfigureSubjectMergesPage";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";


class ConfigureSubjectMergesPage extends BaseConfigureSubjectMergesPage {

    constructor(props: BaseConfigureSubjectMergesPageProps & DispatchProps) {
        super(props);

        const helpContent = (
            <Fragment>
                <b>Please group together duplicates</b><br/><br/>
                You can remove or rename them later.
            </Fragment>
        );
        
        this.state = {
            saveInProgress: false,
            helpTitleText: "Your school data may contain duplicate subjects.",
            helpContent: helpContent,
            helpIcon: "MergeDuplicate"
        }
    }
    
    protected renderContent() {

        if(this.state.subjectMerges === undefined || this.state.sdsSubjects === undefined || this.state.subjectExcludes === undefined)
        {
            return <div/>;
        }
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Subject Merges" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <SubjectMergeEditor onMergesChanged={
                    (subjectMerges) => {
                        this.setState({ subjectMerges: subjectMerges });
                    }}
                    sdsSubjects={this.state.sdsSubjects}
                    subjectMerges={this.state.subjectMerges}
                    subjectExcludes={this.state.subjectExcludes}
                />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): BaseConfigureSubjectMergesPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };

    }
)(ConfigureSubjectMergesPage)